/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import ModulesContext from "../ModulesContext";
import { useEffect, useState } from "react";

function PersonalInfo({ match, goToUpdate, goToDetail, onCancel, formComponent: Form, ...props }) {
    const dispatch = useDispatch();
    const { mode } = props;
    const [consecutive, setConsecutive] = useState(undefined);

    const { PersonalInfo, currentFileCase, resources, module, setCurrentFileCase } = useContext(ModulesContext);

    useEffect(() => {
        async function getNextConsecutive() {
            const consec = await PersonalInfo.getNextConsecutiveAsync();
            setConsecutive(consec);
        }
        getNextConsecutive();
    }, []);

    function onEditHandler() {
        goToUpdate();
    }

    async function onSuccess(savedId, setSubmitting) {
        setSubmitting(false);
        dispatch(notifySuccess(`File Case ${mode === "add" ? "created" : "updated"} successfully!`));
        goToDetail();
        const savedFileCase = await PersonalInfo.getOneByIdAsync(savedId);
        setCurrentFileCase(savedFileCase);
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancel();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    async function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { prefix, consecutive, client, type, status, fileLocation, parent, ...payload } = values;

        const fileNo = `${prefix}${consecutive}`;

        if (!(client && client.id)) {
            dispatch(notifyError("You have to select a client!"));
            setErrors({ client: { lastName: "You have to select a client!" } });
            setSubmitting(false);
            return;
        }

        const apiCall = mode === "add" ? PersonalInfo.add : PersonalInfo.update;

        apiCall({
            payload: {
                id: mode === "update" ? currentFileCase.id : null,
                ...payload,
                fileNo: fileNo.trim().toUpperCase(),
                prefix: prefix.trim().toUpperCase(),
                consecutive,
                clientId: client.id,
                typeId: type ? type.id : null,
                statusId: status ? status.id : null,
                fileLocationId: fileLocation ? fileLocation.id : null,
                parentId: parent && parent.id
            },
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    if (mode !== "add" && !currentFileCase) {
        onCancel();
    }

    return (
        <Page>
            {module && consecutive && (
                <Form
                    fileCase={currentFileCase}
                    resources={resources}
                    {...props}
                    onCancel={onCancel}
                    onSubmit={onSubmitHandler}
                    onEdit={onEditHandler}
                    prefix={module.prefix}
                    consecutive={Number(consecutive)}
                />
            )}
        </Page>
    );
}

PersonalInfo.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
    mode: PropTypes.oneOf(["add", "detail", "update"]).isRequired,
    title: PropTypes.string,
    goToUpdate: PropTypes.func,
    goToDetail: PropTypes.func,
    onCancel: PropTypes.func,
};

PersonalInfo.defaultProps = {
    goToUpdate: () => { },
    goToDetail: () => { },
    onCancel: () => { },
};

export default withRouter(PersonalInfo);
